import React from 'react';
import { Scale } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-16 border-t border-slate-800" data-id="element-152" data-mp="3gf94uw0pu68y">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153" data-mp="3gh3qydnq44em">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-154" data-mp="32p5kybpb6omo">
          <div className="md:col-span-2" data-id="element-155" data-mp="36p6bgupomqa3">
            <div className="flex items-center gap-3 mb-4" data-id="element-156" data-mp="36pzb7bq84fiq">
              <div className="bg-slate-800 p-2 rounded-lg" data-id="element-157" data-mp="3ueiknul0eyce">
                <Scale className="w-5 h-5 text-brand-accent" data-id="element-158" data-mp="3ucxndx7b91au" />
              </div>
              <div className="flex flex-col" data-id="element-159" data-mp="387exl5219eq">
                <span className="font-serif font-bold text-lg leading-tight text-white" data-id="element-160" data-mp="3lelzw41qqjmm">
                  California
                </span>
                <span className="text-[10px] font-semibold tracking-widest text-slate-400 uppercase" data-id="element-161" data-mp="3qc3z32pyhkhf">
                  Mesothelioma Claims
                </span>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-md" data-id="element-162" data-mp="2ez1k2c3i92zd">
              Dedicated exclusively to representing California victims of
              asbestos exposure. We fight for the justice and compensation you
              deserve.
            </p>
          </div>

          <div data-id="element-163" data-mp="3v89eog3s3xhe">
            <h4 className="text-white font-bold mb-4" data-id="element-164" data-mp="3v8rfzr5at1w6">Quick Links</h4>
            <ul className="space-y-2 text-sm" data-id="element-165" data-mp="3q8wq9qx9eicp">
              <li data-id="element-166" data-mp="3q726ifxq4wa7">
                <a href="#why-us" className="hover:text-brand-accent transition-colors" data-id="element-167" data-mp="3qaq0fg72zkpg">
                  Why Choose Us
                </a>
              </li>
              <li data-id="element-168" data-mp="322zr2mj94xe">
                <a href="#results" className="hover:text-brand-accent transition-colors" data-id="element-169" data-mp="htd1p57j9o3z">
                  Case Results
                </a>
              </li>
              <li data-id="element-170" data-mp="qsqea6qyessx">
                <a href="#faq" className="hover:text-brand-accent transition-colors" data-id="element-171" data-mp="qub9lyl3efru">
                  Mesothelioma FAQ
                </a>
              </li>
              <li data-id="element-172" data-mp="two43tyt7h7b">
                <a href="#contact" className="hover:text-brand-accent transition-colors" data-id="element-173" data-mp="tt0ayvxa0wt4">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-174" data-mp="18k959ic4j6cl">
            <h4 className="text-white font-bold mb-4" data-id="element-175" data-mp="18l2c0jb31vuq">Contact</h4>
            <ul className="space-y-2 text-sm" data-id="element-176" data-mp="1clun7i3imatn">
              <li data-id="element-177" data-mp="1cl2rm79x4d3d">
                <a href="tel:805-770-9317" className="hover:text-brand-accent transition-colors font-bold text-white" data-id="element-178" data-mp="1cnoys5swcql2">
                  (805) 770-9317
                </a>
              </li>
              <li data-id="element-179" data-mp="1rj4yaqc8xeou">help@californiamesotheliomaclaims.com</li>
              <li data-id="element-180" data-mp="1rgirwu13d587">Serving all of California</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 text-xs text-slate-500 space-y-4" data-id="element-181" data-mp="3od85lcgo84lz">
          <p data-id="element-182" data-mp="3tai199unlci9">
            <strong data-id="element-183" data-mp="3tc2w70kvqxgn">Disclaimer:</strong> The information on this website is for
            general information purposes only. Nothing on this site should be
            taken as legal advice for any individual case or situation. This
            information is not intended to create, and receipt or viewing does
            not constitute, an attorney-client relationship.
          </p>
          <p data-id="element-184" data-mp="1wlm8g36ijmsj">
            Past results are not a guarantee of future outcomes. Every case is
            different and must be judged on its own merits.
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-4" data-id="element-185" data-mp="2pdflxmv6tu61">
            <p data-id="element-186" data-mp="2kc8hnxs97d44">
              &copy; {new Date().getFullYear()} californiamesotheliomaclaims.com
              — California Mesothelioma Claims. All Rights Reserved.
            </p>
            <div className="flex gap-4" data-id="element-187" data-mp="18ynxtm52r92j">
              <a href="#" className="hover:text-white transition-colors" data-id="element-188" data-mp="18zfrusj0wyqp">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-189" data-mp="141e7835y8rd4">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}